module.exports = __webpack_public_path__ + "static/media/exclamation-circle.46f290bd.svg";